import { InputSize } from '../../utils/shared/input-size/input-size.enum';

export interface TagInputSettings {
  searchable?: boolean;
  size?: InputSize;
}
